export default __webpack_public_path__ + "static/media/reports-plika.491296cb.svg";